const ProfilePage = () => import('@/views/profile/profilePage')

export const profileRootPages = {
  path: '/profile',
  name: 'profile_form_route',
  redirect: {
    name: 'profile_information_route'
  },
  children: [
    {
      path: '',
      component: ProfilePage,
      name: 'profile_information_route'
    },
    {
      path: 'address',
      component: ProfilePage,
      name: 'profile_address_route'
    },
    {
      path: 'connection',
      component: ProfilePage,
      name: 'profile_connection_route'
    },
    {
      path: 'email',
      component: ProfilePage,
      name: 'profile_email_route'
    },
    {
      path: 'notification',
      component: ProfilePage,
      name: 'profile_notification_route'
    },
    {
      path: 'theme',
      component: ProfilePage,
      name: 'profile_theme_route'
    }
  ]
}
